function aleatorio(inferior,superior){ 
    let numPosibilidades = superior - inferior; 
    let aleat = Math.random() * numPosibilidades; 
    aleat = Math.floor(aleat); 
    return parseInt(inferior) + aleat; 
}


function Color_aleatorio(){ 
    const hexadecimal = ["0","1","2","3","4","5","6","7","8","9","A","B","C","D","E","F"]; 
    let color = "#"; 
    for (let i=0; i<6; i++){ 
       let posarray = aleatorio(0,hexadecimal.length) 
       color += hexadecimal[posarray] 
    } 
    return color; 
}

export default {
    Color_aleatorio,
};